module.exports = __webpack_public_path__ + "img/patent_image5.c6c11826.png";